<div class="app-titulo-pagina">
    <span>Pedido de Loja</span>
</div>

<div *ngIf="!mainService.lojaService.pedidoSelecionado.itens.length"
     class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<div *ngIf="mainService.lojaService.pedidoSelecionado.itens.length"
     class="col-xs-12 col-md-6 col-md-offset-3">
    <div class="panel panel-default">
        <div class="panel-heading">Dados do Pedido</div>
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <tr>
                    <td class="text-right">Código:</td> 
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.id }}</td>
                </tr>
                <tr>
                    <td class="text-right">Data de solicitação:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.dataSolicitacao| dateFormat:'dd/MM/yyyy HH:mm' }}</td>
                </tr>
                <tr>
                    <td class="text-right">Status:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.status.status }}
                        <br />
                        <p class="alert alert-warning" 
                           [innerHTML]="mainService.lojaService.pedidoSelecionado.status.mensagem" 
                           *ngIf="mainService.lojaService.pedidoSelecionado.status.status === 'cancelado'" >
                        </p> 
                    </td>
                </tr>
                <tr>
                    <td class="text-right">Previsão de entrega:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.previsaoEntrega }}</td>
                </tr>
                <tr>
                    <td class="text-right">Pontos dos produtos:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.pontos }}</td>
                </tr>
                <tr>
                    <td class="text-right">Frete:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.frete.descricao }}</td>
                </tr>
                <tr>
                    <td class="text-right">Pontos do frete:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.frete.pontos }}</td>
                </tr>
                <tr>
                    <td class="text-right">Pontos totais:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.pontos + mainService.lojaService.pedidoSelecionado.frete.pontos }}</td>
                </tr>
            </table>
        </div>
    </div>

    <div class="panel panel-default">
        <div class="panel-heading">Itens do Pedido</div>
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Parceiro</th>
                        <th>Produto</th>
                        <th>Pontos unitários</th>
                        <th>Quantidade</th>
                        <th>Pontos totais</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor=" let item of mainService.lojaService.pedidoSelecionado.itens">
                        <td>{{ mainService.lojaService.pedidoSelecionado.parceiro.nome }}</td>
                        <td>{{ item.produto.nome }}</td>
                        <td>{{ item.produto.pontos }}</td>
                        <td>{{ item.quantidade }}</td>
                        <td>{{ item.produto.pontos * item.quantidade }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="panel panel-default">
        <div class="panel-heading">Destinatário</div>
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <tr>
                    <td class="text-right">Nome:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.destinatario.nome }}</td>
                </tr>
                <tr>
                    <td class="text-right">Documento:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.destinatario.documento }}</td>
                </tr>
                <tr>
                    <td class="text-right">Email:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.destinatario.email }}</td>
                </tr>
                <tr>
                    <td class="text-right">Telefone:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.destinatario.telefone }}</td>
                </tr>
            </table>
        </div>
    </div>

    <div class="panel panel-default">
        <div class="panel-heading">Endereço de Entrega</div>
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <tr>
                    <td class="text-right">Logradouro:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.enderecoEntrega.logradouro }}</td>
                </tr>
                <tr>
                    <td class="text-right">Número:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.enderecoEntrega.numero }}</td>
                </tr>
                <tr>
                    <td class="text-right">Complemento:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.enderecoEntrega.complemento }}</td>
                </tr>
                <tr>
                    <td class="text-right">CEP:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.enderecoEntrega.cep }}</td>
                </tr>
                <tr>
                    <td class="text-right">Cidade:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.enderecoEntrega.cidade }}</td>
                </tr>
                <tr>
                    <td class="text-right">UF:</td>
                    <td class="text-left">{{ mainService.lojaService.pedidoSelecionado.enderecoEntrega.uf }}</td>
                </tr>
            </table>
        </div>
    </div>
</div>

<br>
<div class="col-xs-12">
    <a (click)="router.navigate(['/loja'])"
       class="btn btn-danger-v2">
        Voltar
    </a>
</div>
<div class="clearfix"></div>


// WEBPACK FOOTER //
// ./src/app/loja/pedido/pedido.component.html